import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Departamento } from "@/shared/types/departamentos";

export async function getDepartamento(id: string): Promise<Departamento> {
    await sleep(1000);
    const response = await api.get("departamento/" + id);
    return response.data;
}

export function useGetDepartamentoQuery(id: string, queryConfig: QueryConfig<Departamento> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getDepartamento(id),
        queryKey: ["departamentos", id],
    })
}

export interface GetDepartamentoQueryProps {
    id: string,
    queryConfig?: QueryConfig<Departamento>,
    children?: (queryResult: QueryResult<Departamento>) => ReactNode
}

export function GetDepartamentoQuery({
    id,
    children,
    queryConfig
}: GetDepartamentoQueryProps) {
    const queryResult = useGetDepartamentoQuery(id, queryConfig);
    return children && children(queryResult);
} 